import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  Container,
  Row,
  Col,
} from 'reactstrap';
import moment from 'moment';
import { Button } from 'components/Button';
import { appConfig } from 'config/appConfig';

const DisclosureModal = ({ isOpen, toggle, scheduledPaymentDate }) => (
  <Modal isOpen={isOpen} toggle={toggle} size="md">
    <ModalBody className="pt-3 pb-2">
      <Container fluid>
        <Row>
          <Col className="pl-0 pr-0">
            <p className="disclosure-content text-center"><b>Thank you for your additional payment!</b></p>
            <p className="disclosure-content">
              {`Please be aware that this payment does not replace your scheduled autopay, which is still set to process on ${moment(new Date(scheduledPaymentDate)).format('MM/DD/YYYY').toString()} as planned. If you wish to make any changes to your autopay, feel free to call us at ${appConfig.servicingPhone}, and we’ll be happy to assist!`}
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-md-center">
            <Button
              color="primary"
              onClick={toggle}
            >
              Close
            </Button>
          </Col>
        </Row>
      </Container>
    </ModalBody>
  </Modal>
);

DisclosureModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  scheduledPaymentDate: PropTypes.string.isRequired,
};

export default DisclosureModal;
